export default "/_next/static/chunks/fonts/RobotoMono-Medium-82231ac16330360f2e1efb884a6ad89c.woff2";